import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrency } from 'selectors';
import { FormattedAmount } from '../../FormattedAmount';

function RoundComponent({ getCurrency, currency, value, ...rest }) {
  const { unitsToRound, subunitToUnit } = getCurrency(currency);
  const roundedSubunits = unitsToRound * subunitToUnit;
  const roundedValue = Math.round(value * roundedSubunits) / roundedSubunits;

  return <FormattedAmount currency={currency} value={roundedValue} {...rest} />;
}

RoundComponent.propTypes = {
  currency: PropTypes.string.isRequired,
  getCurrency: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const mapStateToProps = state => ({
  getCurrency: code => getCurrency(state, code),
});

export const Round = connect(mapStateToProps)(RoundComponent);
